import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import get from 'lodash/get';
import WorkPortfolio
from '../../components/ProfileSearch/ProfileDetails/WorkPortfolio/WorkPortfolio';
import ProfileWorkExperienceSection from './ProfileWorkExperienceSection';

const ProfileMyWorkSection = ({ profile }) => {

  // Filter out projects that don't have video or images
  let portfolioProjects = [];
  if (profile.projects?.length > 0) {
    portfolioProjects = profile.projects.filter(
      (it) => get(it, 'files.images') !== undefined
        || get(it, 'files.videos') !== undefined
    );
  }

  // Don't show My Work section if there is nothing to show
  if (portfolioProjects.length === 0 && !profile.resume && !profile.workExperience) {
    return null;
  }

  return (
    <Row className="p2p-profile__section">
      <Col className="p2p-profile__my-work">
        <h2>My Experience</h2>
        <ProfileWorkExperienceSection profile={profile} />
        <WorkPortfolio projects={portfolioProjects} />
      </Col>
    </Row>
  );
};

export default ProfileMyWorkSection;

ProfileMyWorkSection.propTypes = {
  profile: PropTypes.shape({
    resume: PropTypes.string,
    workExperience: PropTypes.string,
    projects: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string,
      order: PropTypes.number,
      items: [
        {
          id: PropTypes.number,
          video_id: PropTypes.string,
          type: PropTypes.string,
          url: PropTypes.string,
          options: {
            order: PropTypes.number
          },
          is_cover: PropTypes.bool
        }
      ]

    }))
  }).isRequired
};
